import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import MentionsLegales from './pages/MentionsLegales';
import ServicesPage from './pages/ServicesPage';
import TarifsPage from './pages/TarifsPage';
import ReflexologiePage from './pages/ReflexologiePage';
import NaturopathiePage from './pages/NaturopathiePage';
import BlogPage from './pages/BlogPage';
import BlogArticlePage from './pages/BlogArticlePage';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/tarifs" element={<TarifsPage />} />
            <Route path="/reflexologie-angouleme" element={<ReflexologiePage />} />
            <Route path="/naturopathe-angouleme" element={<NaturopathiePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:articleId" element={<BlogArticlePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
